import React from 'react';

const Sockc = props => {
	const socket = props.socket();

	return <>{React.cloneElement(props.children, { socket: socket })}</>;
};

export default Sockc;
